import type {AppConfig} from '../types'
import {__NAME__} from './app-config-name'

export const config: AppConfig = window[__NAME__]

export const isMarketIntegration = config.sourceService === 'market'

export const direction = config.lang === 'he' ? 'rtl' : 'ltr'
